/**
 * Return Medical module instance.
 * @param theViewer viewer instance
 * @return Medical module instance
 * @internal
 */
export function getMedical(theViewer) {
    return theViewer.medicalModule();
}
